import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'repeatableTopics'
})
export class RepeatableTopicsPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
